import { useState, useRef } from 'react';

import Chip from '@zola/zola-ui/src/components/Chip';
import { useResponsiveDesign } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignContext';
import useClickOutside from '@zola/zola-ui/src/hooks/useClickOutside';

import cx from 'classnames';

import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';

import { AvailabilityFilterDayPicker } from '../SearchFacets/AvailabilityFilterDayPicker';

import '../FacetButton/FacetButton.less';

interface CalendarFacetButtonProps {
  /** the label displayed on the button */
  name: string;
  /** selected target date */

  openSideDrawer: () => void;
  isImportant?: boolean;
}

const CalendarFacetButton = (props: CalendarFacetButtonProps): JSX.Element => {
  const { name = 'Error', openSideDrawer, isImportant } = props;
  const { isDesktop } = useResponsiveDesign();

  const [isOpen, setIsOpen] = useState(false);
  const node = useRef<HTMLDivElement>(null);
  const { vendorSearch } = useSearchResultsPageContext();
  const { availabilityDates } = vendorSearch;

  const toggleDropdown = () => {
    if (!isDesktop) {
      openSideDrawer();
      return;
    }
    setIsOpen(!isOpen);
  };

  const onClickOutside = () => {
    setIsOpen(false);
  };

  useClickOutside({ ref: node, isOpen, onClickOutside });

  const isActive = Boolean(availabilityDates?.length);
  const classNames = cx('facet-button__button', { active: isActive });

  const selectedDateCount = availabilityDates?.length ? `(${availabilityDates.length})` : '';

  return (
    <div className="facet-button__container" ref={node} data-is-important={isImportant}>
      <Chip
        className={classNames}
        active={isActive}
        selected={isOpen}
        onClick={toggleDropdown}
        withCaret={isDesktop}
      >
        {`${name} ${selectedDateCount}`}
      </Chip>
      {isOpen && (
        <div className="facet-button__dropdown calendar">
          <AvailabilityFilterDayPicker />
        </div>
      )}
    </div>
  );
};

export default CalendarFacetButton;
